<template>
  <div
    v-if="goalsAspirations.length >= 1"
    class="i-goals-aspirations-home"
  >
    <div class="top">
      <template
        v-for="(goal, index) in goalsAspirations"
        :key="index"
      >
        <div
          v-if="goal && goal.icon && [0, 1].includes(index)"
          class="goal"
        >
          <img
            :src="goal.icon"
            class="icon"
            :style="{ backgroundColor: goal.textColor }"
          />
          <span class="title">{{ goal.title }}</span>
        </div>
      </template>
    </div>
    <div
      v-if="goalsAspirations.length > 2"
      class="bottom"
    >
      <template
        v-for="(goal, index) in goalsAspirations"
        :key="index"
      >
        <div
          v-if="goal && goal.icon && [2, 3].includes(index)"
          class="goal"
        >
          <img
            :src="goal.icon"
            class="icon"
            :style="{ backgroundColor: goal.textColor }"
          />
          <span class="title">{{ goal.title }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useReportStore } from "@/stores/report"

// STORES
const reportStore = useReportStore()

// COMPUTED
const goalsAspirations = computed(() => {
  return [
    reportStore.getTestTakingPurpose,
    reportStore.getCareerGoal,
    reportStore.getIdealCareerFeature,
    reportStore.getMissingNeeds
  ].filter((item) => item !== null)
})
</script>

<style scoped lang="scss">
.i-goals-aspirations-home {
  @include flex(column, start, stretch);

  width: 100%;
  height: 100%;
  overflow: hidden;
  border-top: 1px solid $zumthor100;
  border-bottom: 1px solid $zumthor100;

  @media screen and (min-width: $breakpoint-xl) {
    border-top: none;
  }

  & > div {
    @include flex(row, start, stretch);

    width: 100%;
    height: 100%;

    &:nth-child(2) {
      border-top: 1px solid $zumthor100;
    }

    > .goal:nth-child(2) {
      border-left: 1px solid $zumthor100;
      width: 100%;
    }
  }

  .goal {
    @include grid($cols: 1fr, $rows: 1fr 1fr, $align-items: center, $justify-items: center, $gap: 35px);

    width: 100%;
    padding: 24px;
    background-color: $black50;

    @media screen and (min-width: $breakpoint-xl) {
      padding: 10px;
    }

    .icon {
      width: 45px;
      height: 45px;
      align-self: end;
      background-color: $white;

      @include border-radius-sm;

      padding: 8px;
    }

    .title {
      @include text-md;

      font-weight: 400;
      color: $pickle-bluewood800;
      align-self: start;
      text-align: center;
      max-width: 250px;
    }
  }
}
</style>
